module.exports = __webpack_public_path__ + "static/media/entregado.ae56a86d.svg";